export function formatter(value, Mascara) {
  if (value === undefined || value == null) return value;

  let rawValue = String(value).replace(/[^\d]+/g, '');

  switch (Mascara) {
    case 'TELEFONE':
      return telphoneFormatter(rawValue);
    case 'TELEFONEFAX':
      return telphoneFaxFormatter(rawValue);
    case 'CPFCNPJ':
      return cpfCnpjFormatter(rawValue);
    case 'CPF':
      return cpfFormatter(rawValue);
    case 'CNPJ':
      return cnpjFormatter(rawValue);
    case 'CEP':
      return cepFormatter(rawValue);
    case 'CAIXAPOSTAL':
      return caixaPostalFormatter(rawValue);
    case 'MONETARIO-BRL':
      return monetarioBrlFormatter(value);
    default:
      return value;
  }
}

export function monetarioBrlFormatter(value) {
  return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}

export function telphoneFormatter(value) {
  if (value.length == 11) return value.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
  if (value.length == 10) return value.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
  if (value.length == 9) return value.replace(/^(\d{5})(\d{4}).*/, '$1-$2');
  if (value.length <= 8) return value.replace(/^(\d{4})(\d{0,4}).*/, '$1-$2');
}

export function telphoneFaxFormatter(value) {
  if (value.length == 11) return value.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
  if (value.length == 10) return value.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
  if (value.length == 13) return value.replace(/^(\d{3})(\d{5})(\d{5}).*/, '($1) $2-$3');
  if (value.length == 14) return value.replace(/^(\d{4})(\d{5})(\d{5}).*/, '($1) $2-$3');
  if (value.length == 9) return value.replace(/^(\d{5})(\d{4}).*/, '$1-$2');
  if (value.length <= 8) return value.replace(/^(\d{4})(\d{0,4}).*/, '$1-$2');
}

export function cpfCnpjFormatter(value) {
  if (value.length <= 11) return cpfFormatter(value);
  if (value.length > 11) return cnpjFormatter(value);
}

export function cpfFormatter(value) {
  if (value.length <= 3) return value.replace(/^(\d{3})*/, '$1');
  if (value.length > 3 && value.length <= 6) return value.replace(/^(\d{3})(\d{3})*/, '$1.$2');
  if (value.length > 6 && value.length <= 9) return value.replace(/^(\d{3})(\d{3})(\d{3})*/, '$1.$2.$3');
  if (value.length > 9 && value.length <= 11) return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4');
}

export function cnpjFormatter(value) {
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
}

export function cepFormatter(value) {
  return value.replace(/^(\d{5})(\d{3}).*/, '$1-$2');
}

export function caixaPostalFormatter(value) {
  return value.replace(/^(\d{8}).*/, '$1');
}

export const predefinedMasks = {
  cpf: {
    placeHolder: '___.___.___-__',
    mask: '999.999.999-99',
  },
  cnpj: {
    placeHolder: '__.___.___/____-__',
    mask: '99.999.999/9999-99',
  },
  cpfCnpj: {
    placeHolder: '___.___.___-__',
    mask: '999.999.999-99',
    maskCnpj: '99.999.999/9999-99',
  },
  discagemDireta: {
    placeHolder: '____ ___ ____',
    mask: '9999 999 9999'
  },
  numeroFixo: {
    placeHolder: '____-____',
    mask: '9999-9999'
  },
  telefone: {
    placeHolder: '(__) ____-____',
    mask: '(99) 9999-9999',
    maskCel: '(99) 99999-9999',
  },
  telefoneFax: {
    placeHolder: '(__) ____-____',
    mask: '(99) 9999-9999',
    maskCel: '(99) 99999-9999',
    maskFax: '(9999) 99999-99999',
  },
  cep: {
    placeHolder: '_____-___',
    mask: '99999-999',
  },
  caixapostal: {
    placeHolder: '_________',
    mask: '99999999',
  },
  nit: {
    placeHolder: '___._____.__-_',
    mask: '999.99999.99-9'
  }
};
